import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 随窗口大小改变自定义高度
import ViewportSize from '@/pages/components/autoHeight.vue';
Vue.component('ViewportSize', ViewportSize);

// 引入高德地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);

Vue.config.productionTip = false





new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
